var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value-section py-10"},[_c('div',{class:'font-weight-bold blue--text text--darken-2 text-md-h5 text-lg-h4  text-h5 text-' +
      _vm.align},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.coloredWord))])]),_c('p',{class:' mt-4 grey--text text--darken-2 text-' +
      _vm.align +
      ' ' +
      _vm.size +
      ' ' +
      _vm.width},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }